// extracted by mini-css-extract-plugin
module.exports = {"LayoutTypeSidebarRight":"LayoutTypeSidebarRight_LayoutTypeSidebarRight__2VdJM","main":"LayoutTypeSidebarRight_main__1VOBe","sidebar":"LayoutTypeSidebarRight_sidebar__33itD"};